import React from 'react';
import { MobileStats } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats';
import PCStats from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats';
import ConsoleStats from '@intelligence/pages/TopCharts/ConsoleGames/components/GamesDetails/Stats';
import PCConsoleStats from '@intelligence/pages/TopCharts/PCConsoleGames/components/GamesDetails/Stats';
import useRadioOptionsTipsGetterOfRegionSelect from '@intelligence/hooks/useRadioOptionsTipsGetterOfRegionSelect';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

export default function Countries(props: any) {
  const { entityType } = props;

  const getRadioOptionsTips = useRadioOptionsTipsGetterOfRegionSelect();

  if (entityType === 'mobile') {
    return <MobileStats {...props} tabType={'countries'} />;
  }
  if (entityType === 'pc') {
    return <PCStats {...props} tabType={'countries'} />;
  }
  if (entityType === 'console') {
    return <ConsoleStats {...props} tabType={'countries'} getRadioOptionsTips={getRadioOptionsTips} />;
  }
  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) {
    return (
      <div className="pc-console-combine-details">
        <PCConsoleStats {...props} tabType={'countries'} getRadioOptionsTips={getRadioOptionsTips} />
      </div>
    );
  }
  return null;
}
